// Metro defines `__DEV__` on native and web. Declared locally so the core does
// not depend on react-native's global types.
declare const __DEV__: boolean | undefined;

/** Development means `__DEV__` is true; anywhere it is undefined counts as production. */
export function isDevelopment(): boolean {
  return typeof __DEV__ !== "undefined" && __DEV__;
}
